import get from 'lodash/get'

export const getError = (err, msg) => {
  return get(err, 'response.data.status.message', msg || err.message)
}

export const getSuccess = (resp, msg) => {
  return get(resp, 'body.message', msg)
}
